import React, { useState, ChangeEvent, KeyboardEvent, memo, useEffect, useRef } from 'react';
import './search.scss';
import SEARCH_ICON from '../assets/search_icon.png';

import { useHistory, useLocation, useParams } from 'react-router-dom';

interface IProps {
  className?: string;
  onSearch?: Function;
  hide?: boolean;
}

const map = Object.freeze({
  a: {
    en: 'product code/cas code',
    'zh-cn': '产品编码/CAS编码',
  },
  b: {
    en: 'SEARCH',
    'zh-cn': '产品搜索',
  },
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Search = memo((props: IProps) => {
  const [searchContent, setSearctContent] = useState('');
  const [la, setLa] = useState<'en' | 'zh-cn'>('zh-cn');

  const history = useHistory();

  const query = useQuery();

  const location = useLocation();

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!props.hide) {
      inputRef.current?.focus();
    }
  }, [props.hide]);

  const { lang } = useParams();
  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  const changeInput = (e: ChangeEvent<HTMLInputElement>) => {
    setSearctContent(e.target.value);
  };
  const search = () => {
    if (props.hide) {
      props.onSearch && props.onSearch(searchContent);
    } else {
      query.set('search', searchContent);
      history.push('/' + lang + '/product?' + query.toString());
    }
  };
  const enter = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      search();
    }
  };

  useEffect(() => {
    const search = query.get('search');
    if (search && search !== searchContent) setSearctContent(search);
  }, [location.search]);

  return (
    <div className={`search-bar ${props.className || ''} `}>
      <input
        type='text'
        value={searchContent}
        ref={inputRef}
        className={` ${props.hide === true ? 'hide' : ''}`}
        placeholder={map.a[la]}
        onChange={changeInput}
        onKeyPress={enter}
      />
      <div className='search-botton' onClick={search}>
        <div className='pre-img-icon'>
          <img src={SEARCH_ICON} alt='' />
        </div>
        <div className='search-text'>{map.b[la]}</div>
      </div>
    </div>
  );
});

export default Search;
